import { CheckboxLineInput } from '@sequencehq/core-components'
import { IndigoIndigo60, Link } from '@sequencehq/core-components'
import { BillingType } from 'common/drawers/PricingEditor/domain'

export const BillingTypeField = (props: {
  'data-testid': string
  value: BillingType
  isDisabled: boolean
  onChange: (newValue: BillingType) => void
}) => (
  <CheckboxLineInput
    value={props.value === 'IN_ADVANCE'}
    isDisabled={props.isDisabled}
    onChange={() => {
      const newValue =
        props.value === 'IN_ADVANCE' ? 'IN_ARREARS' : 'IN_ADVANCE'
      props.onChange(newValue as BillingType)
    }}
    text="Bill in advance"
    description={
      <>
        Choose in advance to charge customers upfront. By default customers are
        charged in arrears.{' '}
        <Link
          to="https://docs.sequencehq.com"
          isExternal
          color={IndigoIndigo60}
        >
          Learn more
        </Link>
      </>
    }
    data-testid={props['data-testid']}
  />
)
